import { ApiService } from '../ApiService';
import type {
  FiscalRegime,
  FiscalRegimeTransitionPreview,
  ChangeFiscalRegimePayload,
  ChangeFiscalRegimeResult,
} from '../../../types/fiscal-regime';

/**
 * Endpoints pour la gestion du régime fiscal de l'entreprise.
 *
 * Source backend : `apps/accounting-service/src/modules/organization/controllers/organization.controller.ts`
 */
export const fiscalRegimeApi = {
  /**
   * GET /organization/fiscal-regime/preview
   * Aperçu de la transition vers `newRegime` sans appliquer le changement.
   */
  preview: (newRegime: FiscalRegime) =>
    ApiService.get<{ success: boolean; data: FiscalRegimeTransitionPreview }>(
      '/organization/fiscal-regime/preview',
      { newRegime },
    ),

  /**
   * PATCH /organization/fiscal-regime
   * Évolue le régime fiscal après validation. Le service rejette une
   * transition vers SMT/FORFAITAIRE si TVA déjà comptabilisée.
   */
  change: (payload: ChangeFiscalRegimePayload) =>
    ApiService.patch<{ success: boolean; data: ChangeFiscalRegimeResult }>(
      '/organization/fiscal-regime',
      payload,
    ),
};
